import type {
  AccountEventRequest,
  AccountEventRequests,
  AccountEventsResponse,
  CreateContentEventRequest,
} from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

export function createAccountEvent(transport: Transport, body: AccountEventRequest): Promise<AccountEventsResponse> {
  return operations.postAccountEvent(transport, { body });
}

/** Sends several account events in one request. */
export function createAccountEvents(transport: Transport, body: AccountEventRequests): Promise<AccountEventsResponse> {
  return operations.postAccountEvents(transport, { body });
}

export function createContentEvent(transport: Transport, body: CreateContentEventRequest): Promise<void> {
  return operations.postContentEvents(transport, { contentId: body.contentId, body });
}
